import { useMediaQuery } from 'react-responsive';
import { breakPoints } from '../constants';

export const useDesktop = () =>
    useMediaQuery({
        query: breakPoints.mobile,
    });
